import { Box, Stack, styled } from '@mui/material';

export const StyledInfoWrapper = styled(Stack)(({ theme }) => ({
  width: '100%',
  maxWidth: theme.spacing(168),
  justifyContent: 'space-between',
  paddingTop: theme.spacing(4),
  paddingBottom: theme.spacing(1),
  gap: theme.spacing(1),
  [theme.breakpoints.down('md')]: {
    paddingTop: theme.spacing(5),
  },
}));

export const StyledInfoInner = styled(Box)(({ theme }) => ({
  width: '100%',
  alignSelf: 'flex-start',
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
}));

export const StyledTagsContainer = styled(Stack)(({ theme }) => ({
  flexDirection: 'row',
  height: theme.spacing(4),
  gap: theme.spacing(2),
}));

export const StyledBetaLabelContainer = styled(Box)(({ theme }) => ({
  [theme.breakpoints.down('sm')]: {
    display: 'none',
  },
}));
